import { createSelector } from '@reduxjs/toolkit';
import { BalanceState } from './balanceSlice';

export const getRoot = (state: { balance: BalanceState }) =>
  state.balance as BalanceState;

export const getBalance = createSelector([getRoot], (state) => state.balance);
